import { KeyCodes } from '@/consts/keyCodes';

interface Params {
  onClickAway: () => void;
}

const useInputEvents = ({ onClickAway }: Params) => {
  const onKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    switch (event.key) {
      case KeyCodes.Tab:
      case KeyCodes.Enter:
      case KeyCodes.Escape: {
        onClickAway();
        break;
      }
      default:
        break;
    }
  };

  return { onKeyDown };
};

export default useInputEvents;
